// Phase 15 M1 — React hook that subscribes to the auth store.
//
// Uses `useSyncExternalStore` so React 18 strict-mode renders see a
// consistent snapshot. The hook returns the snapshot + the imperative
// setters; components rarely need both but exposing them in one place keeps
// imports trivial.

import { useSyncExternalStore } from 'react';

import { authStore, type AuthSnapshot } from './store';

export interface UseAuthResult extends AuthSnapshot {
  setSession: typeof authStore.setSession;
  setUser: typeof authStore.setUser;
  logout: typeof authStore.logout;
}

export function useAuth(): UseAuthResult {
  const snapshot = useSyncExternalStore(
    authStore.subscribe,
    authStore.getSnapshot,
    authStore.getSnapshot,
  );
  return {
    ...snapshot,
    setSession: authStore.setSession,
    setUser: authStore.setUser,
    logout: authStore.logout,
  };
}
